
    <div *ngIf="_seconds != undefined" [ngStyle]="{'color': _overdue ? 'orange' : 'var(--main-color)'}">
      <span *ngIf="_days > 0" style="color: inherit;">{{_days}} days, </span>
      <span *ngIf="_days > 0 || _hours > 0" style="color: inherit;">{{_hours}} hours and </span>
      <span style="color: inherit;">{{_minutes}} minutes</span>
      <span *ngIf="showsuffixlabel && _overdue && showoverdue" style="color: inherit;"> overdue</span>
      <span *ngIf="showsuffixlabel && !(_overdue && showoverdue)" style="color: inherit;"> left</span>
    </div>
  